import { render, staticRenderFns } from "./webshop_item.vue?vue&type=template&id=00437fe7&"
import script from "./webshop_item.vue?vue&type=script&lang=js&"
export * from "./webshop_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports